import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useEffect, createElement } from "react";
import { AffordabilityCalculator, AffordabilityCalculatorShape } from "@zillow/zrs-cms";
import { omit, pick } from "lodash";
import PropTypes from "prop-types";
const _zconfigs = {
  prod: {
    serverURLs: {
      MAX: "https://mortgageapi.zillow.com"
    },
    partnerId: "RD-WXDQSGN"
  },
  default: {
    serverURLs: {
      MAX: "https://mortgageapi.qa.zillow.net"
    },
    partnerId: "RD-GKZRBBL"
  }
};
const BlockAffordabilityCalculator = ({
  attrs,
  index
}) => {
  useEffect(() => {
    const _zconfig = _zconfigs[process.env.NEXT_PUBLIC_ENV] || _zconfigs.default;
    if (window._zconfig) {
      if (!window._zconfig.partnerId) {
        window._zconfig.partnerId = _zconfig.partnerId;
      }
      if (!window._zconfig.serverURLs) {
        window._zconfig.serverURLs = {};
      }
      if (!window._zconfig.serverURLs.MAX) {
        window._zconfig.serverURLs.MAX = _zconfig.serverURLs.MAX;
      }
    } else {
      window._zconfig = _zconfig;
    }
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: "zmm-api-config", dangerouslySetInnerHTML: {
      __html: '<!-- {"serverURLs":{}} -->'
    }, style: {
      display: "none"
    } }),
    /* @__PURE__ */ createElement(AffordabilityCalculator, { defaultValues: pick(attrs, Object.keys(AffordabilityCalculatorShape)), ...omit(attrs, Object.keys(AffordabilityCalculatorShape)), key: index })
  ] });
};
BlockAffordabilityCalculator.propTypes = {
  index: PropTypes.number,
  attrs: PropTypes.shape(AffordabilityCalculatorShape)
};
export {
  BlockAffordabilityCalculator as default
};
